<form [formGroup]="formGroup">
  <div class="celo-input-outline">
    <!-- Name -->
    @if (!hideName) {
      @if (readonly) {
        <div class="field-title">Name</div>
        <p class="field-value">{{ name | trim }}</p>
      } @else {
        <mat-form-field appearance="outline" class="name-field">
          <mat-label>Name</mat-label>
          <input
            matInput
            placeholder="Name"
            name="name"
            formControlName="name"
          />
        </mat-form-field>
      }
    }

    <!-- Description -->
    @if (readonly) {
      @if (description) {
        @if (!hideDescriptionHeader) {
          <div class="field-title mt-10">Description</div>
        }
        <p
          #descriptionRef
          class="field-value clamp"
          [innerHtml]="description | trim | linkify"
        ></p>
        @if (isDescriptionOverflowing) {
          <div
            id="read-more"
            class="field-value celo-link"
            role="button"
            (click)="readMore()"
          >
            Read more
          </div>
        }
      }
    } @else {
      <mat-form-field appearance="outline">
        <mat-label>Description</mat-label>
        <textarea
          id="description"
          cdkTextareaAutosize
          #autosize="cdkTextareaAutosize"
          cdkAutosizeMinRows="5"
          cdkAutosizeMaxRows="5"
          matInput
          placeholder="Description"
          name="description"
          formControlName="description"
        ></textarea>
      </mat-form-field>
    }
  </div>
</form>
